import {
  SET_CRUMBS,
  UPDATE_CRUMBS,
} from 'b2b-apps/shop/breadcrumbs/redux/actionTypes';
import {
  CrumbType,
  SetCrumbsAction,
  UpdateCrumbsAction,
} from 'b2b-apps/shop/breadcrumbs/redux/types';

const setCrumbs = (crumbs: CrumbType[]): SetCrumbsAction => ({
  type: SET_CRUMBS,
  payload: {
    crumbs,
  },
});

const updateCrumbs = (crumbs: CrumbType[]): UpdateCrumbsAction => ({
  type: UPDATE_CRUMBS,
  payload: {
    crumbs,
  },
});

export {
  setCrumbs,
  updateCrumbs,
};
